import React, { useState } from "react";
import { Modal, Button, Input } from "antd";

interface DeleteUserConfirmModalProps {
  visible: boolean;
  userName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteUserConfirmModal: React.FC<DeleteUserConfirmModalProps> = ({
  visible,
  userName,
  onConfirm,
  onCancel,
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleCancel = () => {
    setInputValue("");
    onCancel();
  };

  const handleConfirm = () => {
    setInputValue("");
    onConfirm();
  };

  const isConfirmEnabled = inputValue === "eliminar";

  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      footer={null}
      centered
      width={450}
      afterClose={() => setInputValue("")}
    >
      <div style={{ textAlign: "center", padding: "8px 0 16px" }}>
        <h3 style={{ fontWeight: 700, fontSize: 16, marginBottom: 8 }}>
          Eliminar al usuario {userName}
        </h3>
        <p style={{ margin: "0 0 4px" }}>
          ¿Estás seguro de que quieres eliminar al usuario{" "}
          <strong>{userName}</strong>?
        </p>
        <p style={{ fontWeight: 700, margin: "0 0 20px" }}>
          Esta acción es irreversible
        </p>
        <div style={{ textAlign: "left", marginBottom: 20 }}>
          <p style={{ marginBottom: 6 }}>
            Escribe <strong>eliminar</strong> para continuar
          </p>
          <Input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder=""
            onPressEnter={isConfirmEnabled ? handleConfirm : undefined}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
          <Button danger onClick={handleCancel} style={{ minWidth: 90 }}>
            Cancelar
          </Button>
          <Button
            type="primary"
            danger
            disabled={!isConfirmEnabled}
            onClick={handleConfirm}
            style={{ minWidth: 90 }}
          >
            Eliminar
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteUserConfirmModal;
